import React from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Container, Row, Col } from "react-bootstrap";

export default function WhitePaper() {
  return (
    <>
      <Header />
      <div className="bg-darkgrey">
        <section className="whitepaper py-5 ">
          <Container>
            <Row>
              <Col lg={12}>
                <div>
                  <div className="position-relative text-white">
                    <div className="mb-4 pb-1">
                      <h1 className="text-white mb-3">
                        INFI MultiChain Ecosystem
                      </h1>
                      <h3 className="text-white mb-3">
                        Powered by the ©SbSe Protocol
                      </h3>

                      <p className="text-white">
                        Redefining Decentralised Digital Infrastructure & Web4 Technology
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h4 className="text-white">1. Executive Summary</h4>
                      <p className="text-light-grey">
                        The INFI MultiChain Ecosystem, powered by the advanced ©SbSe Protocol, is a comprehensive
                        blockchain platform designed to shape the next phase of decentralised digital infrastructure. It
                        supports a wide range of sectors, including AI integration, on-chain utility mapping, gaming
                        environments, decentralised applications, and intelligent automation tools.
                      </p>
                      <p className="text-light-grey">
                        At its foundation, INFI functions as a community-oriented blockchain utility framework. The
                        ecosystem promotes autonomous protocol governance, transparent user engagement, and
                        decentralised interaction models.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h4 className="text-white mb-4">2. Vision and Mission</h4>

                      <div className="mb-4">
                        <h5 className="text-white mb-3">Vision</h5>
                        <p className="text-light-grey">
                          To build a transparent, user-led decentralised ecosystem that empowers participants and enables
                          digital innovation across diverse sectors.
                        </p>
                      </div>
                      <div>
                        <h5 className="text-white mb-3">Mission</h5>

                        <ul className="text-light-grey lh-lg">
                          <li>
                            Deliver a secure, decentralised, multi-chain environment for blockchain-based applications.{" "}
                          </li>
                          <li>
                            Encourage protocol participation through on-chain activity recognition.{" "}
                          </li>
                          <li>
                            Enable the digital representation of various data and assets across interoperable networks.
                          </li>
                          <li>
                            Advance Web4 infrastructure through AI-enhanced blockchain architecture.{" "}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="mb-4 pb-1">
                      <h4 className="text-white mb-3">
                        3. The ©SbSe Protocol: Core Infrastructure of the Ecosystem
                      </h4>
                      <p className="text-light-grey">
                        The ©SbSe Protocol is an intelligent, adaptive automation system that operates the core logic of the
                        INFI MultiChain Ecosystem. Designed for decentralisation and long-term scalability, the protocol
                        governs system behavior without reliance on third-party control.
                      </p>
                      <div className="mb-4">
                        <h5 className="text-white mb-3">Key Innovations:</h5>

                        <ul className="text-light-grey lh-lg">
                          <li>
                            Autonomous oversight of utility logic, including engagement rewards, swap mechanics, and
                            project onboarding.
                          </li>
                          <li>
                            Enhances operational transparency and decentralised coordination.
                          </li>
                          <li>
                            Removes the need for custodial access or platform-controlled balances.
                          </li>
                          <li>
                            Enables real-time interaction tracking and system evolution.
                          </li>
                        </ul>
                      </div>
                      <div>
                        <h5 className="text-white mb-3">Technical Innovations:</h5>

                        <ul className="text-light-grey lh-lg">
                          <li>
                            <strong className="text-white">
                              Self-Building System Architecture:{" "}
                            </strong>{" "}
                            An evolving, automated framework
                          </li>
                          <li>
                            <strong className="text-white">
                              Activity Mapping Pools:
                            </strong>{" "}
                            Participation data is logged and visually traceable
                          </li>
                          <li>
                            <strong className="text-white">
                              Event Buffering Logic:
                            </strong>{" "}
                            48-hour review layer for high-impact system events.
                          </li>
                          <li>
                            <strong className="text-white">
                              Cross-Network Support:{" "}
                            </strong>{" "}
                            Seamlessly operates across 14 supported blockchain
                            environments.
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="mb-4 pb-1">
                      <h4 className="text-white mb-3">4. Core Functional Modules</h4>

                      <div className="mb-4">
                        <h5 className="text-white mb-3">
                          <span><img src="images/greensquare.svg" width={`20px`} alt="" /></span>&nbsp;&nbsp;INFI MultiChain Exchange Layer (CDEX)
                        </h5>
                        <p className="text-light-grey mb-3">
                          A decentralised, user-governed smart contract system for digital asset exchanges:
                        </p>
                        <ul className="text-light-grey lh-lg">
                          <li>Operates across 14 chains</li>
                          <li>Asset-to-asset transactions only</li>
                          <li>No fiat connections or onboarding</li>
                          <li>Includes optional KYC tools, network monitoring, and system hygiene protocols</li>
                          <li>Features activity-based benefits and transparent usage record-keeping</li>
                        </ul>
                      </div>
                      <div className="mb-4">
                        <h5 className="text-white mb-3">
                          <span><img src="images/greensquare.svg" width={`20px`} alt="" /></span>&nbsp;&nbsp;Autonomous Project Onboarding (Launchpad)
                        </h5>
                        <p className="text-light-grey mb-3">
                          Startup-friendly system for deploying projects with multi-network reach:
                        </p>
                        <ul className="text-light-grey lh-lg">
                          <li>Integrated project onboarding engine </li>
                          <li>Usage-based visibility without listing fees </li>
                          <li>Optional access to campaign tools</li>
                        </ul>
                      </div>
                      <div className="mb-4">
                        <h5 className="text-white mb-3">
                          <span><img src="images/greensquare.svg" width={`20px`} alt="" /></span>&nbsp;&nbsp;SbSe Order Mapping Layer (SbSe OTC)
                        </h5>
                        <p className="text-light-grey mb-3">
                          A peer-engagement tool that supports coordinated value swaps with:
                        </p>
                        <ul className="text-light-grey lh-lg">
                          <li>Usage-based participation metrics </li>
                          <li>Optional promotional configurations </li>
                          <li>Privacy-conscious architecture </li>
                        </ul>
                      </div>
                      <div className="mb-4">
                        <h5 className="text-white mb-3"><span><img src="images/greensquare.svg" width={`20px`} alt="" /></span>&nbsp;&nbsp;INFI Instant Interaction Engine</h5>
                        <p className="text-light-grey mb-3">
                          Smart contract-based value exchange system:
                        </p>
                        <ul className="text-light-grey lh-lg">
                          <li>Supports rapid execution </li>
                          <li>Operates without third-party intermediaries </li>
                          <li>Connected to the broader SbSe automation network </li>
                        </ul>
                      </div>
                      <div className="mb-4">
                        <h5 className="text-white mb-3"><span><img src="images/greensquare.svg" width={`20px`} alt="" /></span>&nbsp;&nbsp;Upcoming Modules</h5>

                        <ul className="text-light-grey lh-lg">
                          <li>
                            <strong className="text-white">
                              INFI Hybrid Utility Wallet
                            </strong>{" "} - A smart storage and transaction environment
                          </li>
                          <li>
                            <strong className="text-white">INFI Digital Operations Suite (Web4)</strong>{" "} -
                            Tools for advanced dApp coordination{" "}
                          </li>
                          <li>
                            <strong className="text-white">
                              Integration Layers for NFTs, AI, and external data systems
                            </strong>{" "}
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="mb-4 pb-1">
                      <h4 className="text-white">5. Community Interaction & Governance</h4>

                      <div className="mb-4">
                        <p className="text-light-grey my-3">
                          INFI ecosystem participants contribute to decision-making through an automated governance layer.
                        </p>
                        <h6 className="text-white mb-3 fw-normal">
                          Features Include :
                        </h6>
                        <ul className="text-light-grey lh-lg">
                          <li>
                            Decentralised voting on proposed system changes
                          </li>
                          <li>
                            Participation logic for engagement-based roles
                          </li>
                          <li>
                            Transparent overview of system activity mapping
                          </li>
                        </ul>
                      </div>
                      <div className="mb-4">
                        <h6 className="text-white mb-3 fw-normal">
                          System Activity Pools

                        </h6>
                        <ul className="text-light-grey lh-lg">
                          <li>
                            <strong className="text-white">Engagement Pools : </strong>
                            Record usage volume and assign internal utility credits
                          </li>
                          <li>
                            <strong className="text-white">Buffer Pools : </strong>
                            Designed to rebalance system conditions following major fluctuations
                          </li>
                        </ul>
                      </div>

                    </div>
                    <div className="mb-4 pb-1">
                      <h4 className="text-white">6. Application Focus Areas</h4>
                      <div className="mb-4">
                        <p className="text-light-grey">
                          The INFI MultiChain Ecosystem is built to support a wide range of blockchain-based applications
                          and user groups, including:

                        </p>
                        <ol className="text-light-grey lh-lg">
                          <li>Builders of decentralised platforms and tools</li>
                          <li>Digital gaming frameworks</li>
                          <li>SME and startup blockchain adopters</li>
                          <li>Public-sector technology integration</li>
                          <li>AI-enhanced digital coordination services</li>
                        </ol>
                      </div>
                    </div>
                    <div className="mb-4 pb-1">
                      <h4 className="text-white mb-3">7. System Utility Model</h4>
                      <div>
                        <p className="text-white mb-1">
                          INFI Utility Contract Address:
                        </p>
                        <p className="fw-bold">
                          <a
                            href="https://polygonscan.com/address/0x0CC9b5290d920bDC966E93205241D0eE07b5799f"
                            target="_blank"
                            rel="noopener noreferrer"
                          > 0x0CC9b5290d920bDC966E93205241D0eE07b5799f
                          </a>
                        </p>
                      </div>
                      <div className="mb-4">
                        <p className="text-light-grey">
                          <strong className="text-white">Total Units Available : </strong>
                          2,000,000 INFI
                        </p>
                        <Row>
                          <Col lg={5}>
                            <div className="text-light-grey lh-lg">
                              <table className="table table-bordered table-striped w-100">
                                <thead>
                                  <tr>
                                    <th>Allocation Category</th>
                                    <th>Amount (INFI)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {/* <tr>
                                    <td>SbSe Protocol Module</td>
                                    <td>600,000</td>
                                  </tr> */}
                                  <tr>
                                    <td>Initial Distribution</td>
                                    <td>1,600,000</td>
                                  </tr>
                                  <tr>
                                    <td>Community & System
                                      Reserves</td>
                                    <td>200,000</td>
                                  </tr>
                                  <tr>
                                    <td>On-Chain Utility Buffer</td>
                                    <td>200,000</td>
                                  </tr>
                                </tbody>
                              </table>
                              <ul className="text-light-grey lh-lg ps-3">
                                <li>
                                  <strong className="text-white">Network : </strong>
                                  Polygon
                                </li>
                                <li>
                                  <strong className="text-white">Reference Price at Launch : </strong>
                                  5 USDT / INFI
                                </li>
                                <li>
                                  <strong className="text-white">Public Release Method : </strong>
                                  INFI Token Distribution Event (ICO)
                                </li>
                              </ul>
                            </div>
                            {/* <div className="card">
                              <div className="card-body">
                                <img src="images/whitepaperchart.png" className="w-100" alt="" />
                              </div>
                            </div> */}
                          </Col>
                          <Col lg={12}>

                            <p className="text-light-grey lh-lg mb-0">
                              ⚠ <strong className="text-white">Disclaimer : </strong> The INFI ICO is a decentralised token distribution event designed to support utility
                              access within the INFI MultiChain Ecosystem. Participation does not constitute a financial
                              investment and should not be interpreted as investment advice, a securities offering, or a solicitation
                              in any regulated jurisdiction. Participants are responsible for their own due diligence and use of the
                              INFI token strictly within the ecosystem's utility framework.
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <div className="mb-4 pb-1">
                      <h4 className="text-white mb-4">8. Contributor Insights</h4>
                      <div className="mb-4">
                        <h5 className="text-white mb-2">
                          Odon Oszkar Horvath
                        </h5>
                        <p className="text-light-grey mb-2">
                          “We’re building systems that adapt, evolve, and stay transparent by design. Our focus is lasting
                          infrastructure, not hype.”
                        </p>
                      </div>
                      <div className="mb-4">
                        <h5 className="text-white mb-2">
                          Sven Schönwald
                        </h5>
                        <p className="text-light-grey mb-2">
                          “AI and blockchain together let us create smarter, more resilient digital ecosystems. INFI is our
                          contribution to this future.”
                        </p>
                      </div>
                      <div className="">
                        <h5 className="text-white mb-2">
                          Laszlo Kellner
                        </h5>
                        <p className="text-light-grey mb-2">
                          “My role is to make these tools usable and impactful. Community-led innovation is what drives this
                          ecosystem forward.”
                        </p>
                      </div>
                    </div>
                    <div className="mb-4 pb-1">
                      <h4 className="text-white">9. Operational Base</h4>
                      <p className="text-light-grey">
                        Dubai was selected as our global coordination hub for its alignment with emerging digital
                        technologies and decentralised infrastructure initiatives.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h4 className="text-white">10. Conclusion</h4>
                      <p className="text-light-grey">
                        The INFI MultiChain Ecosystem and the ©SbSe Protocol together offer a fully decentralised, userempowered, and technology-first infrastructure for a future built on autonomy and transparency.
                        From digital coordination to protocol-based engagement, the platform offers a flexible foundation
                        for next-generation decentralised applications — without relying on financial incentives, custodial
                        control, or investment products.
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Footer />
    </>
  );
}
